<script>
    export let image = "https://www.pngall.com/wp-content/uploads/13/Doordash-Logo.png";
    export let link = "https://www.doordash.com/search/store/burger?event_type=search"

    function OpenLink(){
        window.open(link);
    }
</script>
<style>
    .circle{
        background-color: white;
        border-radius: 50%;
        height: 5em;
        width: 5em;
        display: inline-flex;
        align-items: center;
        align-content: center;
        justify-content: center;
        user-select: none;
    }
    img{
        max-width: 3.5em;
        max-height: 3.5em;
        user-select: none;
    }
    @media only screen and (max-width: 900px) {
        .circle{
            background-color: white;
            border-radius: 50%;
            height: 5em;
            width: 5em;
            display: inline-flex;
            align-items: center;
            align-content: center;
            justify-content: center;
        }
        img{
            max-width: 3.5em;
            max-height: 3.5em;
        }
    }
    @media only screen and (max-width: 700px) {
        .circle{
            background-color: white;
            border-radius: 50%;
            height: 4em;
            width: 4em;
            display: inline-flex;
            align-items: center;
            align-content: center;
            justify-content: space-around;
        }
        img{
            max-width: 2.5em;
            max-height: 2.5em;
        }
    }
    @media only screen and (max-width: 400px) {
        .circle{
            background-color: white;
            border-radius: 50%;
            height: 2.5em;
            width: 2.5em;
            display: inline-flex;
            align-items: center;
            align-content: center;
            justify-content: space-around;
        }
        img{
            max-width: 1.75em;
            max-height: 1.75em;
        }
    }
</style>
<body>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="circle" on:click={OpenLink}>
        <img src={image} alt="Icon"> 
    </div>

</body>